import { defineAsyncComponent } from 'vue';
import { ELI_SETTINGS_ROUTE_NAMES } from './components/EliSettings/constants';

export { default as EliHeadWithShadow } from './components/EliHeadWithShadow.vue';
export { default as EliSuggestionButton } from './components/EliSuggestionButton/EliSuggestionButton.vue';
export type { EliSuggestion } from './components/EliSuggestionButton/types';
export type { EliContextData } from './types';

export const eliMicroFrontends = {
	EliSettingsPage: defineAsyncComponent(
		() => import('./components/EliSettings/EliSettingsPage.vue')
	),
	EliSmartFilter: defineAsyncComponent(
		() => import('./components/EliSmartFilter/EliSmartFilter.vue')
	),
};

export const eliSettingsRoutes = [
	{
		path: '/settings/eli/usage',
		name: ELI_SETTINGS_ROUTE_NAMES.USAGE,
		component: () => import('./components/EliSettings/EliSettingsPage.vue'),
	},
	{
		path: '/settings/eli',
		name: ELI_SETTINGS_ROUTE_NAMES.SETTINGS,
		component: () => import('./components/EliSettings/EliSettingsPage.vue'),
	},
];
